import ConsentTransactionID from '../constants/consentTransactionID';
import api from './api';
import { NextApiRequest, NextApiResponse } from 'next';

type ConsentCheckBoxPayload = {
  consentCredit: number;
  phoneNumber: string;
  customerName: string;
  transactionTypeID: ConsentTransactionID;
  salesOfficeCode?: string;
  nikNo?: string;
};

const submitUuPdp = (payload: {
  consentStatusId: number;
  phoneNumber?: string;
  customerName?: string;
}) => {
  return api.post(
    '/api/submit-uu-pdp',
    null,
    { ...payload },
    {
      baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
    }
  );
};

const handleSubmitUUPDPV2 = async (payload: ConsentCheckBoxPayload) => {
  try {
    return api.post(
      '/api/submit-uu-pdp',
      null,
      { ...payload },
      {
        baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
      }
    );
  } catch (error) {
    console.log({ error });
  }
};

const handleSubmitUUPdp = async (payload: {
  consentStatusId: number;
  phoneNumber?: string;
  customerName?: string;
}) => {
  try {
    await submitUuPdp(payload);
  } catch (error) {
    console.log({ error });
  }
};

export const getPdpAll = (isAll: boolean = false) => {
  return api.get(`customer/v1/saphybris/pdp-consent?isAll=${isAll ? 'true' : 'false'}`);
};

export const apiSubmitUUPDPCheckbox = async (req: NextApiRequest, res: NextApiResponse) => {
  try {
    const body: ConsentCheckBoxPayload = req.body;
    if (
      typeof body?.consentCredit !== 'number' ||
      body?.consentCredit > 1 ||
      body?.consentCredit < 0 ||
      !body?.phoneNumber ||
      !body?.customerName ||
      !body?.transactionTypeID
    )
      return res.status(400).json({ error: 'Error Parameter' });
    const pdpConsentData = body;
    const response = await api.put(
      `customer/v1/saphybris/pdp-consent`,
      null,
      { ...pdpConsentData },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return res.status(200).json(response?.data || { message: 'Submit UU PDP Succesfull' });
  } catch (error) {
    console.log(error);
    return res
      .status(error?.response?.data?.status ?? 500)
      .json(error?.response?.data ?? { error: 'Internal Server Error' });
  }
};

const checkPdpConsent = async () => {
  try {
    const res = await api.get('api/pdp-consent-check', {
      baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
    });
    return res;
  } catch {
    return {
      data: {
        show: false,
      },
    };
  }
};

export default { submitUuPdp, getPdpAll, handleSubmitUUPdp, checkPdpConsent, handleSubmitUUPDPV2 };
